module.exports = __webpack_public_path__ + "NoeDisplay-Bold.015941c5b90675044f8e.eot";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.eot
// module id = ../../../../../src/assets/fonts/NoeDisplay-Bold/NoeDisplay-Bold.eot
// module chunks = styles